import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LocalUserChoices } from '@livekit/components-react';
import { LiveKitRoomStreamGo } from '../../..';
import { setLiveKitRoomProps } from '../../../../redux/slices/auth';
import { RootState } from '../../../../redux/store';
import { useCheckMutation } from '../../../../redux/streamGoApi';
import { TestRoom } from './TestRoom';

interface ILiveKitTestRoom {
  connected: boolean;
  setConnected: (connected: boolean) => void;
  userChoices: LocalUserChoices;
}

export const LiveKitTestRoom = ({
  connected,
  setConnected,
  userChoices,
}: ILiveKitTestRoom) => {
  const roomId = 'TEST';
  const [check] = useCheckMutation();

  useEffect(() => {
    check({ roomId });
  }, [check, roomId]);

  const { isAuthenticated } = useSelector((state: RootState) => state.auth);

  const dispatch = useDispatch();

  useEffect(() => {
    if (isAuthenticated && userChoices) {
      const liveKitRoomProps = {
        hq: false,
        roomName: roomId,
        userChoices,
      };

      dispatch(setLiveKitRoomProps(liveKitRoomProps));
    }
  }, [dispatch, isAuthenticated, userChoices]);

  const onLeave = useCallback(() => {}, []);

  return (
    <LiveKitRoomStreamGo onDisconnected={onLeave}>
      <TestRoom connected={connected} setConnected={setConnected} />
    </LiveKitRoomStreamGo>
  );
};
